<template>
  <div class="body">
    <div class="descricao">
        <p class="label-search">Se confirmar, todas as alterações não salvas serão perdidas. Deseja realmente continuar?</p>
    </div>

    <div class="conteiner-icone">
        <i class="fas fa-exclamation-circle icone"></i>
    </div>

    <div class="d-flex container_cancel_save">
        <div class="cancelar">
            <button class="button-cancel" @click="cancel">CANCELAR</button>
        </div>
        <div class="criar">
            <button class="button-save" @click="retonar">RETORNAR</button>
        </div>
    </div>
  </div>

</template>

<script>
import returnGridTemplate from './returnGridTemplate'
export default returnGridTemplate
</script>

  <style scoped>
  .conteiner-icone {
    display: flex;
    justify-content: center;
  }
  .icone {
    font-size: 60px;
    color: #046437;
  }
  .label-search{
    font-family: 'Segoe UI';
    font-size: 14px;
    text-align: center;
    font-weight: bold;
    color: rgb(67, 67, 67);
    width: 100%;
  }
   .margin {
    margin-top: 1rem;
   }
  .body{
    width: 100%;
    padding: 1rem;
  }
  .nome-epi{
    color: rgb(116, 116, 116);
    font-size: 13px;
    font-family: 'Segoe UI';
  }
 .descricao{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
 }

 .container_cancel_save{
  justify-content: center;
  width: 100%;
  margin-top: 1.5rem;
  column-gap: 20px;
 }

 .button-cancel{
   background-color: #b60000;
   color: white;
 }
 .button-save{
  background-color: #046437;
  color: white;
 }

.button-cancel,
.button-save{
  margin-top: 10;
  font-size: 12PX;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}

</style>



// WEBPACK FOOTER //
// src/views/private/apr/templateApr/components/returnGridTemplate/returnGridTemplate.vue